module.exports = __webpack_public_path__ + "static/005-09d8ecfebd761620a8705c080b361f51.png";